import { Menu } from '../../Component/index.js'

export const Sidebar = () => (
  // Below the top bar on desktop; scrolls itself, so every entry stays reachable on a short screen.
  <div className="drawer-side h-screen lg:h-[calc(100vh-4rem)]">
    <label htmlFor="sidebar-drawer" className="drawer-overlay" />
    <aside className="w-72 bg-base-200 p-3 h-full overflow-y-auto">
      <Menu />
    </aside>
  </div>
)
